export const generateMercantileValue = (value: number) => {
  const hundredths = +(value % 0.1).toFixed(2)[3];
  if (hundredths !== 5) {
    return value.toFixed(1);
  }
  return (value + 0.01).toFixed(1);
};
